import { FC } from 'react';
import {
  SectionBreadcrumbs,
  SectionBreadcrumbsProps,
} from '../../common/SectionBreadcrumbs';
import { ROLE_ROUTES } from './Roles';

export interface RoleBreadcrumbsData {
  name: string;
}

export type RoleBreadcrumbsProps = Omit<
  SectionBreadcrumbsProps<RoleBreadcrumbsData>,
  'routes'
>;

export const RoleBreadcrumbs: FC<RoleBreadcrumbsProps> = (props) => (
  <SectionBreadcrumbs {...props} routes={ROLE_ROUTES} />
);
